import { useCallback, useState } from 'react';

// Typeahead selections retain identity; typing or clearing discards the old ID.
export function useTransferDestination() {
  const [selection, setSelection] = useState({ text: '', id: null });
  const onChange = useCallback((text, option) => {
    setSelection({ text, id: option?.id ?? null });
  }, []);
  return [selection.text, onChange, selection.id];
}

export function resolveTransferDestination(locations, selectedId, findByText) {
  if (selectedId !== null && selectedId !== undefined) {
    // Never substitute a same-name record for an explicit selection.
    return locations.find((location) => String(location.id) === String(selectedId));
  }
  return findByText();
}
